// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__15r5J","dragIcon":"Choice_dragIcon__-D0YF","left":"Choice_left__2d31A","input":"Choice_input__1SlDK"};